import { StatsigProvider } from '@statsig/react-bindings';
import React, { ReactNode } from 'react';
import { useBriefConfig } from '../../context';

export function StatsigConfiguration({ children }: { children: ReactNode }) {
    const briefConfig = useBriefConfig();
    return (
        <StatsigProvider
            sdkKey={briefConfig.statsigServerKey}
            user={{
                userID: '',
            }}
        >
            {children}
        </StatsigProvider>
    );
}
